const messages = {
  invalidFieldLatLong: 'Debe ingresar una coordenada valida.',
  invalidLengthLatLong: 'La coordenada debe tener 5 decimales.',
  blocked: 'Cuenta bloqueada, no puede realizar transacciones',
  cancelled: 'Cuenta cerrada, no puede realizar transacciones',
  onlydebit: 'Cuenta bloqueada, no puede realizar transacciones',
  onlycredit: 'Cuenta bloqueada, no puede realizar transacciones',
  required: 'Campo requerido',
  formatIncorrect: 'El formato es incorrecto',
  usersImportFileFormat: 'Archivo no compatible. Solo se permiten archivos .xlsx y .csv.',
  importMissingHeader: 'Falta la columna',
  usersImportDownloadTemplate: 'Descargar plantilla',
  usersImportValidationErrors: 'El archivo tiene filas con errores. Corrija el documento antes de iniciar la carga.',
  usersImportNoRows: 'No hay usuarios válidos en el archivo.',
  usersImportSummaryTotal: 'Total',
  usersImportSummaryImported: 'Importados',
  usersImportSummaryFailed: 'Fallidos',
  usersImportImportedTitle: 'Usuarios importados',
  usersImportFailedTitle: 'Usuarios con error',
  usersImportWarningsTitle: 'Avisos',
  usersImportLine: 'Línea',
  usersImportUser: 'Usuario',
  usersImportEmail: 'Email',
  usersImportReason: 'Motivo',
  usersImportCode: 'Código',
  usersImportSeeDetails: 'Ver detalle',
  usersImportRoleNotAllowed: 'rol no permitido',
  hello: 'Hola',
  userWelcomeText: '¿Qué vamos a realizar hoy?',
  wellcome: 'Bienvenid@',
  seeDetail: 'Ver detalle',
  showingData: 'Mostrando data',
  noData: 'No hay registros disponibles',
  personalAdministration: 'Administración de Personal',
  areYouSure: '¿Estas seguro?',
  areYouSureDeleteUser: '¿Estas seguro de eliminar al usuario?',
  areYouSureDeleteSubsidiary: '¿Estas seguro de eliminar la subsidiaria?',
  activeCashier: 'Activar Cajero',
  open: 'Abrir',
  close: 'Cerrar',
  ok: 'OK',
  openned: 'Abierto',
  closed: 'Cerrado',
  notFound: 'El enlace en el que hizo clic puede estar roto o la página puede haber sido eliminada',
  usersDetails: 'Usuarios corresponsal',
  requiredField: 'Campo requerido',
  checkRequiredFields: 'Revise los campos marcados en el formulario.',
  errorLoadingRoles: 'No se pudieron cargar los roles.',
  roleRequiredHint: 'Seleccione primero un corresponsal.',
  addUser: 'Crear usuarios para funcionarios del banco y asignar un rol específico.',
  editUser: 'Modificar usuarios para funcionarios del banco y asignar un rol específico.',
  addUserCorrespondent: 'Crear usuarios para Corresponsales y asignar un rol específico.',
  adminCorrespondentRoleWarning:
    'Estás creando un Administrador Corresponsal. Este usuario podrá crear, modificar y eliminar usuarios de tu comercio, y una vez creado no podrá ser editado ni eliminado desde esta pantalla. Asígnalo solo a personal autorizado.',
  editUserCorrespondent: 'Modificar usuarios para Corresponsales y asignar un rol específico.',
  auth0_idp_error: 'El Usuario o el email ya fueron registrados',
  resetPassword: '¿Deseas cambiar o recuperar tu contraseña?',
  insertEmail: 'Ingresa tu correo electrónico para buscar tu cuenta.',
  emailNotRegister: 'El correo o número que ingresó no coincide con ninguna cuenta, contacte a su supervisor.',
  forgotPassword: '¿Olvidaste tu contraseña?',
  changePassword: 'Cambio de contraseña',
  successChangePassword: 'Se ha actualizado la contraseña',
  passwordProfile: 'Es recomendable tener una contraseña única para que el sitio sea seguro.',
  subsidiaryDescription: 'Administración de la información de la Sucursal.',
  subsidiariesDescription: 'Alta/Baja Sucursales Corresponsal.',
  tenantSelect: '¿Dónde vas a trabajar hoy?',
  tenantDescription: 'Selecciona tu lugar de trabajo para continuar.',
  authorizationCorrespondent: 'Habilitación del corresponsal.',
  correspondentBranches: 'Sucursales del corresponsal',
  selectDay: 'Seleccione al menos un dia.',
  cashOut: 'Retirar dinero',
  insertData: 'Ingrese los datos',
  amountInBs: 'Monto en Bs',
  disclaimer: 'Motivo del depósito',
  cashoutDisclaimer: 'Motivo del retiro',
  loadingMoneyWallet: 'Carga de dinero a billetera',
  monday: 'lunes',
  tuesday: 'martes',
  wednesday: 'miércoles',
  thursday: 'jueves',
  friday: 'viernes',
  saturday: 'sábado',
  sunday: 'domingo',
  invalidPhone: 'Teléfono invalido',
  invalidBolivianCellphone: 'El celular debe tener 8 dígitos',
  invalidOtpCode: 'OTP inválido',
  sendEmailRequestChangePassword: 'Se envió un link a su correo para que pueda restablecer su contraseña.',
  confirmPasswordNoMatch: 'La contraseña no coincide',
  strongPassword: 'Mayúsculas, minúsculas, números, caracteres especiales, al menos 6 dígitos',
  succeededResetPassword: 'La contraseña se ha cambiado satisfactoriamente, Ingrese al sistema',
  enterValidName: 'Ingresa un nombre valido',
  enterValidLastName: 'Ingresa un apellido valido',
  enterValidAsfiCode: 'Ingresa un código ASFI válido.',
  enterValidMail: 'Ingresa un email válido',
  notSubsidiaryAssigned: 'No tienes una sucursal asignada aún.',
  noSubsidiariesEnabled: 'No hay sucursales habilitadas para este corresponsal.',
  firstNameTooLong: 'Nombre muy largo.',
  lastNameTooLong: 'Apellido muy largo.',
  enterValidAccountNumber: 'Ingresa un número de cuenta válido.',
  scheduleConflicts: 'Existe conflictos entre los horarios',
  userModified: 'Usuario Modificado correctamente',
  userAdded: 'Usuario creado correctamente',
  resetPasswordText: 'Registre una nueva contraseña para el usuario',
  securePassword: 'Incluya letras, al menos una mayúscula, números y los caracteres *.#-@',
  theUser: 'El usuario',
  unlockedUserMessage: 'ha sido desbloqueado. Será redirigido a la página de inicio de sesión',
  invalidUnlockUserHash: 'El hash utilizado no es válido.',
  incorrectCurrentPassword: 'La contraseña actual es incorrecta',
  passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
  passwordTooLong: 'La contraseña es demasiado larga',
  passwordMustHaveNumber: 'La contraseña debe contener al menos un número',
  passwordMustHaveSpecialChar: 'La contraseña debe contener al menos un carácter especial (ej. ! @ # $ % & * + -)',
  passwordMustHaveUppercase: 'La contraseña debe contener al menos una letra mayúscula',
  passwordMustHaveLowercase: 'La contraseña debe contener al menos una letra minúscula',
  passwordInvalidChars: 'La contraseña contiene caracteres no permitidos',
  notNotification: 'No tiene notificaciones para reenviar',
  confirmUnlockUser: '¿Está seguro que desea desbloquear este usuario? Recuperará acceso inmediatamente.',
  selectUsersToUnlock: 'Seleccione los usuarios que desea desbloquear.',
  unexpectedError: 'Sucedió un error inesperado, por favor contacte con el administrador.',
  bringingInMoney: 'Depositando dinero a la cuenta',
  verifiedPerson: 'Usuario verificado',
  enterValidSender: 'Debe ingresar un carnet Valido',
  addBasicPerson: 'Agregar Persona Básica',
  identification: 'Carnet de identidad',
  bringInMoney: 'Abono de dinero',
  enterData: 'Ingrese los datos',
  enterValidAccount: 'Debe ingresar un celular Valido',
  accountBalance: 'Saldo Cuenta Pago',
  visualizeAccount: 'Visualiza el saldo de la cuenta del corresponsal',
  balanceAt: 'Saldo al',
  inBs: 'en Bs.',
  bsCurrency: 'Bs.',
  enterValidAmount: 'Debe ingresar datos válidos',
  minAmount: 'Monto mínimo para el depósito es de 1 Bs.',
  negativeNotPermited: 'No se permiten números negativos',
  errorGetContact: 'Error al intentar obtener el contacto',
  errorUpdateContact: 'Error al intentar modificar el contacto',
  enterValidCI: 'Ingresa un número de carnet válido',
  pendingRegister: 'Registro pendiente de aprobación, verifique el estado nuevamente',
  enterValidValue: 'Introduzca un número válido',
  enterValidDate: 'Introduzca una fecha válida',
  subsidiariesImportInvalidDate: 'Fecha inválida. Use el formato DD-MM-YYYY (ej. 10-01-2025).',
  userUnderAge: 'El usuario es menor de edad',
  withoutData: 'Sin datos',
  CashierReport: 'Reporte de Caja',
  cashinMessage: 'Recibes dinero físico, y abonas dinero electrónico a la billetera',
  cashoutMessage: 'Recibes dinero electrónico, y entregas dinero físico al cliente',
  amountToGiveInBs: 'Monto a entregar',
  noAsignment: 'Sin asignar',
  cashRegisterReport: 'Reporte apertura/Cierre Cajas',
  cashinIndeterminate:
    'No devuelva el efectivo hasta recibir la confirmación. Por favor espere unos minutos mientras confirmamos el depósito.',
  cashinIndeterminateTitle: 'Depósito en proceso',
  cashinVerifyingSlow:
    'La confirmación está demorando más de lo habitual. La pantalla se actualizará sola; si necesita ayuda, comuníquese con soporte e indique el código de la operación.',
  cashinOperationCode: 'Código de la operación',
  cashinVerifiedRejectedTitle: 'Depósito rechazado',
  cashinVerifiedRejectedBody: 'El dinero no fue depositado a la billetera. Puede devolver el efectivo al cliente.',
  cashinUnconfirmedTitle: 'No se puede confirmar el pago',
  cashinUnconfirmedBody:
    'La conexión se cerró antes de confirmar el depósito. Puede haberse realizado. Revise el registro antes de devolver el efectivo o repetir el abono.',
  cashinViewRegister: 'Ver registro',
  cashinUnverifiedTitle: 'Depósito sin verificar',
  cashinUnverifiedBody:
    'No se pudo verificar si el depósito se realizó. Revise el reporte de transacciones antes de devolver el efectivo o repetir el abono.',
  cashinNotProcessedTitle: 'Depósito no realizado',
  cashinNotProcessedBody: 'El dinero no llegó a la billetera. Puede intentarlo nuevamente con los mismos datos.',
  cashinInProgress:
    'El depósito anterior sigue en proceso. Espere unos segundos y vuelva a intentar sin modificar los datos.',
  cashinInterruptedChecking: 'Verificando el depósito',
  cashinInProgressBanner: 'Depósito en proceso',
  cashinInterruptedCompletedTitle: 'Depósito realizado',
  cashinInterruptedDepositor: 'Carnet del depositante',
  cashinDuplicateBlockedTitle: 'Transacción similar reconocida',
  cashoutIndeterminate:
    'No se pudo confirmar el retiro. Verifique en el reporte de transacciones si fue procesado antes de entregar el dinero o volver a intentar.',
  supportCode: 'Código de soporte',
  supportCodeCopy: 'Copiar código de soporte',
  supportCodeCopied: 'Copiado',
  reportProblem: 'Reportar problema',
  reportProblemTitle: 'Reportar un problema',
  reportProblemDescription:
    'Se enviará una captura de la pantalla actual al equipo de soporte. Los datos personales del cliente se ocultan antes de enviarla.',
  reportProblemComment: '¿Qué pasó? (opcional)',
  reportProblemSend: 'Enviar reporte',
  reportProblemCancel: 'Cancelar',
  reportProblemSent: 'Reporte enviado. Código de soporte: ',
  reportProblemFailed: 'No se pudo enviar el reporte. Intente nuevamente.',
  clientErrorsTitle: 'Errores reportados por cajeros',
  clientErrorsDescription:
    'Errores capturados en el navegador de los usuarios, con captura de pantalla cuando corresponde.',
  clientErrorsDate: 'Fecha',
  clientErrorsDateFrom: 'Desde',
  clientErrorsDateTo: 'Hasta',
  clientErrorsUser: 'Usuario',
  clientErrorsCorrespondent: 'Corresponsal',
  clientErrorsSource: 'Origen',
  clientErrorsKind: 'Tipo',
  clientErrorsCode: 'Código',
  clientErrorsStatus: 'HTTP',
  clientErrorsUrl: 'Servicio',
  clientErrorsRequestId: 'Request ID',
  clientErrorsRoute: 'Pantalla',
  clientErrorsAppVersion: 'Versión',
  clientErrorsMessage: 'Mensaje',
  clientErrorsComment: 'Comentario',
  clientErrorsAll: 'Todos',
  clientErrorsSearch: 'Buscar',
  clientErrorsView: 'Ver',
  clientErrorsDetailTitle: 'Detalle del error',
  clientErrorsScreenshot: 'Captura de pantalla',
  clientErrorsScreenshotFailed: 'No se pudo cargar la captura de pantalla.',
  cashinDuplicateBlocked:
    'Se realizó una transacción similar con los mismos datos recientemente. Para repetir esta acción espera 5 minutos antes de volver a intentarlo.',
  massiveLoadBranches: 'Carga masiva de sucursales',
  massiveLoadBranchesFile: 'Selecciona un archivo para iniciar el proceso de carga.',
  subsidiariesImportDownloadTemplate: 'Descargar plantilla',
  subsidiariesImportFileFormat: 'Archivo no compatible. Solo se permiten archivos .xlsx y .csv.',
  subsidiariesImportCorrespondentRequired: 'Seleccione un corresponsal para iniciar la carga.',
  subsidiariesImportCityRequired: 'Seleccione una ciudad para iniciar la carga.',
  subsidiariesImportValidationErrors:
    'El archivo tiene filas con errores. Corrija el documento antes de iniciar la carga.',
  subsidiariesImportNoRows: 'No hay sucursales válidas en el archivo.',
  subsidiariesFound: 'Sucursales encontradas',
  importErrorNumber: 'N°',
  subsidiariesImportSeeDetails: 'Ver detalle',
  userFound: 'Usuarios encontrados',
  rowsError: 'Errores en el documento',
  startImport: 'Iniciar carga',
  uploadFile: 'Cargando archivo',
  subsidiaryActive: 'El corresponsal ya tiene una sucursal en activo.',
  subsidiaryNameDuplicated: 'El nombre de sucursal ya existe',
  otpMessageInput: 'Ingresa el código enviado a tu celular ',
  userCheck: 'Usuario autenticado',
  getNewOTP: 'Recibir un nuevo código',
  massScheduleUpload: 'Carga masiva de horarios',
  selectSchedule: 'Selecciona un horario',
  assignSchedules: 'Asignar horarios',
  assignNewSchedules: 'Asignar nuevos horarios',
  results: 'Resultados',
  maxAmount: 'El monto máximo por transacción es de Bs. 5000',
  notSubsidiaryUserAsigned: 'Debe agregar un usuario y una sucursal',
  notUserAsigned: 'Debe agregar un usuario',
  cryptoErrorMessage:
    'No se pudo completar la transacción porque tu transferencia está asociada a la comercialización de criptomonedas.',
  minComission: 'Porcentaje debe ser mayor a 0',
  maxComission: 'Porcentaje máximo es de 1',
  whiteListDesc: 'Permite el acceso al sistema sólo para los usuarios de la lista',
  addUserWhiteList: 'Agregar usuario',
  activate: 'activar',
  deactivate: 'desactivar',
  selectDateSearch: 'Seleccione un intervalo de fechas para su búsqueda.',
  minLength: 'El número mínimo de caracteres es de $1.',
  maxLength: 'El número máximo de caracteres es de $1.',
  correspondentRemittanceFeatureDescription: 'Selecciona las operaciones que podrá realizar este corresponsal',
  errorCreateCorrespondent: 'Error al crear el corresponsal',
  errorUpdateCorrespondent: 'Error al actualizar el corresponsal',
  errorCorrespondentStatus: 'No se pudo obtener el estado del corresponsal. Intente nuevamente.',
  permanentCloseWarning:
    'El cierre definitivo es irreversible: el corresponsal no podrá volver a habilitarse ni editarse. Escriba el Número BASS $1 para confirmar.',
  errorGetCorrespondents: 'No se pudo cargar la lista de corresponsales. Intente nuevamente.',
  backToLogin: 'Regresar al inicio de sesión',
  backToHomePage: 'Volver a la página de inicio',
  remittanceReportEmptyTitle: 'No hay pagos de giros',
  remittanceReportEmptyHint: 'Intenta cambiando el rango de fechas y pulsa Buscar',
  correspondentsReportEmptyTitle: 'No hay corresponsales para mostrar',
  correspondentsReportEmptyHint: 'Ajusta los filtros para encontrar corresponsales',
  errorUploadImage: 'No se pudo subir la imagen. Intente nuevamente.',
  'CORR/size-limited': 'La imagen excede el tamaño máximo permitido. Use una imagen más liviana.',
  'CORR/format-not-allowed': 'Imagen en formato no compatible, solo se permite imagenes de tipo JPEG, JPG y PNG.',
  'CORR/upload-failed': 'No se pudo subir la imagen. Intente nuevamente.',
};

const labels = {
  actions: 'Acciones',
  warning: 'Advertencia',
  action: 'Acción',
  administrator: 'Administrador',
  city: 'Ciudad',
  close: 'Cerrar',
  closed: 'Cerrada',
  correspondent: 'Corresponsal',
  ciSender: 'Carnet de identidad del depositante',
  ok: 'OK',
  id: 'Id',
  nit: 'Nit',
  notFound: 'Página no encontrada',
  register: 'Registrar',
  search: 'Buscar',
  selectFile: 'Seleccionar Archivo',
  username: 'Usuario',
  password: 'Contraseña',
  start: 'Inicio',
  login: 'Ingresar',
  reports: 'Reporte',
  reportTransactions: 'Reporte de transacciones',
  printReport: 'Imprimir reporte',
  noTransactionsToPrint: 'No hay transacciones para imprimir',
  remittancePaymentsReport: 'Reporte de Pagos de Giros',
  remittancePaymentsReportDescription: 'Consulte y exporte los pagos realizados en el rango de fechas seleccionado.',
  open: 'Abierta',
  date: 'Fecha',
  dateConcilation: 'Fecha de Conciliación',
  hour: 'Hora',
  cashier: 'Cajero',
  type: 'Tipo',
  amount: 'Monto',
  result: 'Resultado',
  entries: 'Entradas',
  outputs: 'Salidas',
  balance: 'Balance',
  subsidiary: 'Sucursal',
  state: 'Estado',
  actives: 'Activos',
  inactives: 'Inactivos',
  name: 'Nombre',
  add: 'Agregar',
  yes: 'Si',
  no: 'No',
  cancel: 'Cancelar',
  back: 'Atras',
  user: 'Usuario',
  totalCashin: 'Total Entradas',
  totalCashout: 'Total salidas',
  income: 'Ingresar',
  cashTitle: 'Gestión Cajas',
  backToTop: 'Regresar al inicio',
  cashRegSubheader: 'Apertura y cierre de cajas',
  initialDate: 'Hora de apertura',
  initialDateTime: 'Fecha apertura',
  finalDate: 'Hora de cierre',
  users: 'Usuarios',
  names: 'Nombres',
  lastNames: 'Apellidos',
  email: 'Email',
  role: 'Rol',
  ci: 'Carnet de Identidad',
  enable: 'Activar',
  disable: 'Desactivar',
  addUser: 'Agregar Usuario',
  editUser: 'Editar Usuario',
  modify: 'Modificar',
  remove: 'Eliminar',
  reset: 'Recuperar',
  edit: 'Editar',
  error: 'Error',
  withdrawalRejected: 'Retiro rechazado',
  newPassword: 'Nueva contraseña',
  insertNewPassword: 'Ingrese su nueva contraseña',
  confirmNewPassword: 'Confirmar Nueva Contraseña',
  confirm: 'Confirmar',
  myProfile: 'Mi perfil',
  changePassword: 'Cambiar contraseña',
  adminProfile: 'Administrar mi perfil',
  current: 'Actual',
  savePassword: 'Guardar Cambios',
  subsidiaryLabel: 'Sucursal',
  subsidiaries: 'Sucursales',
  supervisor: 'Supervisor',
  supervisors: 'Supervisores',
  cashiers: 'Cajeros',
  deletedDate: 'Fecha Eliminada',
  addSubsidiary: 'Agregar Sucursal',
  newSubsidiary: 'Nueva Sucursal',
  editSubsidiary: 'Editar Sucursal',
  editCorrespondentRequest: 'Editar Solicitud',
  desCorrespondentRequest: 'Editar Solicitud de Corresponsal',
  managementCorrespondents: 'Gestión de corresponsales',
  managementCorrespondentsDetails: 'Revisa las sucursales',
  newCorrespondent: 'Nuevo Corresponsal',
  closeCorrespondent: 'Cierre del Corresponsal',
  typeCorrespondent: 'Tipo de corresponsal',
  IdCorrespondent: 'ID Corresponsal',
  businessName: 'Razón social',
  tradeName: 'Nombre Corresponsal',
  bankAccount: 'Cuenta Bancaria',
  bassId: 'Número BASS',
  following: 'Siguiente',
  phone: 'Teléfono',
  temporary: 'Temporal',
  definitive: 'Definitivo',
  shutdown: 'Cerrar',
  save: 'Guardar',
  reasonClose: 'Motivo del cierre',
  confirmBassId: 'Confirmar Número BASS',
  closePermanently: 'Cerrar definitivamente',
  enableCorrespondent: 'Habilitar',
  currentStatus: 'Estado Actual',
  enableCorFormTitle: 'Habilitar corresponsal',
  address: 'Dirección',
  schedule: 'Horarios',
  insertName: 'Ingrese el nombre',
  insertId: 'Ingrese el Id',
  insertState: 'Ingrese el estado',
  emailAddress: 'Correo electrónico',

  all: 'Todos',
  activate: 'Activar',
  enableSubsidiary: 'Activar sucursal',
  currentState: 'Estado actual',
  uploadPicture: 'Subir Foto',
  nameSubsidiary: 'Nombre de la sucursal',
  asfi: 'Código ASFI',
  latitude: 'Latitud',
  length: 'Longitud',
  specifyLocation: 'Especifique la ubicación',
  insertCode: 'Ingrese el código',
  locationMap: 'Ubicación en el mapa',
  openingHoursTitle: 'Horarios de atención',
  days: 'Días',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  backTo: 'Volver',
  enableCorrText1: 'El corresponsal pasará al estado: Activo',
  enableCorrText2: 'Informe al corresponsal que puede iniciar operaciones.',
  closeSubsidiary: 'Cierre de Sucursal',
  targetCell: 'Celular de destino',
  client: 'Cliente',
  clientCI: 'CI',
  tokenOtp: 'Token OTP',
  check: 'Verificar',
  verified: 'Verificado',
  depositMoney: 'Depositar Dinero',
  withdrawalMoney: 'Retiro de Dinero',
  amountWithdrawn: 'Monto retirado, Bs',
  transactionDetails: 'Datos de la transacción',
  transactionId: 'ID de transacción',
  dateAndTime: 'Fecha y Hora',
  successfulWithdrawal: 'Retiro Exitoso',
  number: 'Numero',
  filter: 'Filtro',
  selectFilter: 'Seleccionar filtro',
  fromDate: 'Fecha desde',
  toDate: 'Fecha hasta',
  exportData: 'Exportar',
  correspondentsReport: 'Reporte de corresponsales',
  socialReason: 'Razón Social',
  registeredDate: 'Fecha registro',
  enabledDate: 'Fecha activación',
  lastChangedDate: 'Fecha último estado',
  upDate: 'Fecha de Alta',
  closedDAte: 'Fecha de baja',
  enabledUsers: 'Usuarios activos',
  subsidiariesReport: 'Reporte de Sucursales',
  correspondentSubsidiariesReport: 'Reporte de Sucursales de corresponsal',
  subsidiarySupervisors: 'Supervisores de sucursal',
  addSupervisor: 'Agregar supervisor',
  destiny: 'Destino',
  content: 'Contenido',
  seeNotifications: 'Ver notificaciones',
  accept: 'Aceptar',
  go: 'Ir',
  resendNotification: 'Reenviar notificación',
  send: 'Enviar',
  message: 'Mensaje',
  unlock: 'Desbloquear',
  unlockUser: 'Desbloquear Usuario',
  amountBringIn: ' Monto depositado',
  requesterAccount: 'CI. Remitente',
  destinationAccount: 'Cuenta destino',
  cashinDetails: 'Detalles de depósito',
  bringInFrom: 'Celular del Destinatario',
  bringInFromName: 'Nombre del Destinatario',
  bringInTo: 'Recibido por',
  complement: 'Complemento',
  months: 'meses',
  reason: 'Motivo',
  contactInformation: 'Información del contacto',
  notificationChannel: 'Datos para envío de comprobante electrónico',
  mailChannel: 'Correo del depositante',
  smsNotificationChannel: 'Nro. celular del depositante',
  smsChannel: 'SMS',
  cellphone: 'Celular',
  complete: 'Completar',
  marriedName: 'Apellido Casada',
  optional: 'Opcional',
  commissionsToPay: 'Comisiones por pagar',
  commissionsPaid: 'Comisiones pagadas',
  cutDay: 'Dia de corte',
  timePeriod: 'Periodo de tiempo',
  totals: 'Totales',
  checkCommissionsPaidDetail: 'Ver detalle de cobros',
  checkCommissionsToPayDetail: 'Ver detalle de pagos',
  from: 'Desde',
  to: 'Hasta',
  paids: 'Pagadas',
  toPay: 'Por pagar',
  contact: 'Contacto',
  subsidiaryId: 'ID sucursal',
  correspondentId: 'ID corresponsal',
  stateDate: 'Fecha del estado',
  usersReport: 'Reporte usuarios corresponsal',
  usersReportDescription: 'Usuarios de corresponsales',
  lock: 'Bloqueado',
  temporalPassword: 'Password Temporal',
  userState: 'Estado usuario',
  profileState: 'Estado Perfil',
  profileCreatedAt: 'Fecha perfil creado',
  profileDisabledAt: 'Fecha perfil eliminado',
  roleCreatedAt: 'Fecha rol asignado',
  subsidiaryCreatedAt: 'Fecha sucursal asignada',
  start_date: 'Fecha de inicio',
  loading: 'Cargando',
  loadingRoles: 'Cargando roles...',
  selectRole: 'Seleccione un rol',
  noRolesAvailable: 'Sin roles disponibles',
  retry: 'Reintentar',
  contractDate: 'Fecha contrato',
  contractDuration: 'Duración contrato',
  updatedStatus: 'Actualizar estado',
  here: 'aqui',
  transactions: 'Transacciones',
  transaction: 'Transacción',
  imageSize: 'La imagen excede el tamaño máximo de $1MB.',
  imageFormat: 'Imagen en formato no compatible, solo se permite imagenes de tipo JPEG, JPG y PNG.',
  removePicture: 'Quitar foto',
  usersImportTitle: 'Carga Masiva de Usuarios',
  usersImportDetails: 'Selecciona un archivo para iniciar el proceso de carga.',
  usersImportButton: 'Cargar Usuarios',
  managementUserBank: 'Gestión Usuarios Banco',
  userBank: 'Usuarios Banco',
  nroDocument: 'Nro. de Documento',
  issued: 'Expedido',
  birdthDate: 'Fecha de nacimiento',
  setSchedule: 'Asignación de horarios',
  setScheduleTitle: 'Asignando horarios',
  success: 'Correcto',
  concilationReport: 'Conciliaciones',
  report: 'Reporte',
  idBank: 'ID Banco',
  accountingEntry: 'Asiento',
  channel: 'Canal',
  bill: 'Factura',
  quantum: 'Importe',
  idTransaction: 'ID Transaccional',
  typeTransaction: 'Tipo Transaccional',
  commission: 'Comisión',
  commissionReport: 'Comisiones Corresponsal',
  generateReport: 'Generar Reporte',
  typeTransactions: 'Tipo Transacción',
  count: 'Cantidad',
  total: 'Total',
  operationType: 'Tipo de operación',
  paidDate: 'Fecha Pago',
  service: 'Servicio',
  ownerName: 'Nombre del titular',
  registrationDate: 'Fecha de registro',
  uptadedDate: 'Fecha de actualización',
  personInCharge: 'Responsable',
  updatedDate: 'Última actualización',
  requestManagement: 'Gestión de Solicitudes',
  requestManagementDescription: 'Pequeños corresponsales',
  manager: 'Responsable',
  reference: 'Referencia',
  oldInMonths: 'Antiguedad en meses',
  department: 'Departamento',
  accountNumber: 'Número de Cuenta',
  commercialName: 'Nombre del Comercio',
  stateChange: 'Estado al que cambió',
  openCash: 'Abrir caja',
  account: 'Cuenta',
  Corresponsal: 'Corresponsal',
  Sucursal: 'Sucursal',
  Rol: 'Rol',
  rolesByCrspTitle: 'Roles tipo de corresponsal',
  rolesByCrspDesc: 'Define los roles que participan en cada corresponsal',
  roles: 'Roles',
  assigned: 'Asignados',
  availableRoles: 'Roles disponibles',
  cashin: 'Abono',
  cashout: 'Retiro',
  cashinComission: 'Ej. 0.3',
  cashoutComission: 'Ej. 0.3',
  toogleStatus: 'Estado lista blanca',
  bank: 'Banco',
  correspondents: 'Corresponsales',
  home: 'Home',
  payment: 'Pago',
  notes: 'Notas',
  topaz: 'Topaz',
  rowsPerPage: 'Filas por página',
  lengthCount: 'de',
  noteDialogTitle: 'Notas de seguimiento',
  noteDialogSubtitle: 'Agrega las notas para tener tu seguimiento actualizado.',
  noteInputDialogLabel: 'Nota',
  noteDialogCancelButton: 'Cancelar',
  noteDialogAddButton: 'Agregar',
  matter: 'Importe',
  comision: 'Comisión',
  comisions: 'Comisiones',
  withoutPay: 'Sin pagar',
  savedPeriods: 'Periodos guardados',
  executedPeriods: 'Periodos ejecutados',
  rejectionReason: 'Motivo de rechazo',
  rejectionReasonRequiredField: 'Se debe especificar un motivo de rechazo',
  correspondentName: 'Nombre Corresponsal',
  rolesPageTitle: 'Gestión de Roles',
  roleCode: 'Código',
  roleName: 'Nombre del Rol',
  roleType: 'Tipo de Rol',
  addRole: 'Agregar Rol',
  editRole: 'Editar Rol',
  roleManagement: 'ABCM de roles',
  roleManagementDescription: 'Agregue, edite y elimine roles',
  roleNameAlreadyExists: 'El nombre del rol ya existe',
  roleManagementStepOne: 'Paso 1: Cree un rol y tipo de corresponsal.',
  roleManagementStepTwo: 'Paso 2: Seleccione los permisos para el rol creado',
  roleManagementSelectError: 'Seleccionar al menos una opcion',
  roleDetails: 'Detalles del Rol',
  rolePermissions: 'Permisos del Rol',
  correspondentRemittanceFeature: 'Funciones',
  correspondentRemittance: 'Pago de Giros',
  beneficiary: 'Beneficiario',
  clave: 'Clave',
  place: 'Plaza',
  agency: 'Agencia',
  currency: 'Moneda',
  seat: 'Asiento',
  status: 'Estado',
  transactionNumber: 'Número Transacción',
  dateCell: 'Fecha',
  hourCell: 'Hora',
  totalAmount: 'Monto total (Bs)',
  quantityTransaction: 'Cantidad Transacciones',
  month: 'Mes',
  year: 'Año',
  correspondentDataSection: 'Datos del corresponsal',
  contractSection: 'Contrato',
  accountSection: 'Cuenta de abono',
  ciHelper: 'Solo números, de 5 a 10 dígitos',
  cellphoneHelper: '8 dígitos',
  numbersOnlyHelper: 'Solo números',
  temporaryClose: 'Cierre temporal',
  definitiveClose: 'Cierre definitivo',
  temporaryCloseDescription: 'Se puede reactivar después.',
  definitiveCloseDescription: 'No se puede deshacer. El corresponsal deja de ser editable.',
  moreActions: 'Más acciones',
  emailPlaceholder: 'nombre@empresa.com.bo',
  stepOf: 'Paso $1 de $2',
  editCorrespondentTitle: 'Editar Corresponsal',
};

export { labels, messages };
